import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import type { THeading } from './models';

export const Heading: FC<THeading> = ({ Text, heading, headingView, step, styles }) => {
    const stepsWithoutHeading = ['error', 'thanksPage', 'delivery', 'draft', 'gentleErrorPage'];

    return stepsWithoutHeading.includes(step) ? null : (
        <Text
            className={cn(styles?.flexibleDesignHeading, styles?.external)}
            styler={{ margin: 0, padding: 0 }}
            view={headingView}
        >
            {heading}
        </Text>
    );
};
